export default {
  "b2b.cookies-content.text":
    "Tento web využívá výhradně nezbytné technické soubory cookies."
};
